import { render, staticRenderFns } from "./ImotEditPopup.vue?vue&type=template&id=6c0848c0"
import script from "./ImotEditPopup.vue?vue&type=script&lang=js"
export * from "./ImotEditPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports